import { ApiService } from '@flicent/fieldpulse-react-component-library-frontend';

import { API_ORIGIN } from '@/constants';

export const JobApiService = new ApiService(API_ORIGIN);